import { render, staticRenderFns } from "./DeleteTargetCab.vue?vue&type=template&id=74c1e180"
import script from "./DeleteTargetCab.vue?vue&type=script&lang=js"
export * from "./DeleteTargetCab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports